import { cn } from "@/lib/utils";

const VARIANTS = {
  draft:      "border-zinc-700 text-zinc-400",
  queued:     "border-blue-700/60 text-blue-400",
  publishing: "border-amber-600/60 text-amber-400",
  published:  "border-emerald-700/60 text-emerald-400",
  failed:     "border-red-700/60 text-red-400",
  cancelled:  "border-zinc-700 text-zinc-500 line-through",
  success:    "border-emerald-700/60 text-emerald-400",
  json_parse_failed: "border-amber-600/60 text-amber-400",
  validation_failed: "border-amber-600/60 text-amber-400",
  imported:   "border-zinc-700 text-zinc-300",
  generated:  "border-blue-700/60 text-blue-400",
  active:     "border-emerald-700/60 text-emerald-400",
};

export default function StatusPill({ status, className }) {
  const variant = VARIANTS[status] || "border-zinc-700 text-zinc-400";
  return (
    <span className={cn("inline-block px-2 py-0.5 text-[10px] uppercase tracking-wider txt-mono border rounded-sm", variant, className)}>
      {status || "—"}
    </span>
  );
}
